import ColdPackFeeModal from './ColdPackFeeModal';

export default ColdPackFeeModal;
